import { replaceWithOptionalTranslation } from "./replace_with_optional_translation";

const TRANSLATION_KEY_PREFIX = 'filter';

export function replaceWithOptionalFilterLabelTranslation(
    filterValueToBeTranslated,
    label,
) {
    return replaceWithOptionalTranslation(filterValueToBeTranslated, label, TRANSLATION_KEY_PREFIX);
}
